enum BenefitType {
  DiscountBenefit = 1,
  ProductBenefit = 2,
}

export default BenefitType;
